import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "../lib/auth";
import { formatError } from "../lib/api";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@spicy.gg");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user?.role !== "admin") {
        setErr("This account does not have admin access.");
        setLoading(false);
        return;
      }
      navigate("/admin");
    } catch (e) {
      setErr(formatError(e.response?.data?.detail) || e.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_60%_50%_at_50%_40%,rgba(230,0,0,0.25),transparent_70%)]" />
      <div className="w-full max-w-md">
        <Link to="/" data-testid="login-brand" className="flex items-center gap-2.5 justify-center mb-8">
          <img
            src="/brand/logo.png"
            alt="Spicy Community"
            className="h-10 w-10 rounded-full object-cover ring-1 ring-red-500/40 shadow-[0_0_18px_rgba(230,0,0,0.6)]"
          />
          <span className="font-display font-extrabold text-xl">
            SPICY<span className="text-red-500">.</span>COMMUNITY
          </span>
        </Link>
        <div className="glass-red-glow rounded-2xl p-8">
          <h1 className="font-display font-black text-3xl mb-2">Admin Console</h1>
          <p className="text-zinc-400 text-sm mb-6">
            Sign in to manage tournaments, brackets and the live feed.
          </p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-widest text-zinc-500 font-mono">Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 w-full bg-black/50 border border-white/10 rounded-xl px-4 py-3 focus:outline-none focus:border-red-500 transition-all"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-zinc-500 font-mono">Password</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 w-full bg-black/50 border border-white/10 rounded-xl px-4 py-3 focus:outline-none focus:border-red-500 transition-all"
              />
            </div>
            {err && (
              <div data-testid="login-error" className="text-sm text-red-400 bg-red-950/40 border border-red-500/30 rounded-lg p-3">
                {err}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="btn-liquid w-full btn-liquid-lg"
            >
              <LogIn size={16} /> {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
          <div className="mt-6 pt-4 border-t border-white/5 text-xs text-zinc-500 font-mono">
            Demo: admin@spicy.gg / SpicyAdmin2026!
          </div>
        </div>
      </div>
    </div>
  );
}
